import { customElement, property } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
import logoWebp from './assets/pdq-flow.webp';
import logoPng from './assets/pdq-flow.png';
import { center, row } from '../styles';
import { annotation } from './common';

@customElement('pdq-tutorial-welcome')
class PDQTutorialWelcome extends LitElement {
  @property({ type: String }) title = 'PDQ-Flow';
  @property({ type: String }) description = 'Data retrieval and visualization tool for PDQ data.';
  @property({ type: String }) imageUrl = logoWebp;
  @property({ type: String }) imageFallbackUrl = logoPng;

  static styles = [
    row,
    center,
    annotation,
    css`
        :host {;
            display: block;
            max-width: 800px; /* Adjust the width as needed */
            margin: 0 auto; /* Center the tile horizontally */
            padding: 20px; /* Padding around the content inside the tile */
        }

        cds-tile {
            --cds-tile-padding: 2rem;
            background: transparent; /* Make the tile background transparent */
        }


    `];

  render() {
    return html`
      <cds-tile class="row center">
        <picture>
          <source srcset="${this.imageUrl}" type="image/webp">
          <img class="annotation" src="${this.imageFallbackUrl}" alt="PDQ-Flow logo">
        </picture>
        <div>
          <h1>${this.title}</h1>
          <p>Data retrieval, and visualization in the browser</p>
          <p>This tutorial will show the main concepts, components and configuration options for pdq-flow</p>
        </div>
      </cds-tile>
    `;
  }
}